export default __webpack_public_path__ + "assets/images/aistudio/94f4b04e9175cba04e6469a7b47ee408.png";